// Import styles
import "../styles/main.scss";

// Import npm Modules
import LazyLoad from "vanilla-lazyload";

// Import vendors
import { documentReady } from "./vendors/events";

// Import components
import Carousel from "../components/elements/carousel";
import Tooltip from "../components/elements/tooltip";
import Modal from "../components/elements/modal";
import skipNavigation from "../components/elements/skipNavigation";

import Module from "../components/modules/module";
import Calculator from "../components/modules/calculator";

import Accordion from "../components/templates/accordion";
import LongCopy from "../components/templates/longCopy";
import Readmore from "../components/elements/readmore";
import FaqAccordionsFilter from "../components/templates/faqAccordionsFilter";
import PartnerDownloadsFilter from "../components/templates/partnerDownloadsFilter";

import MainNav from "../components/templates/mainnavigation";
import { handleImageSizes } from "./vendors/_helpers";

!window.app && console.error("Application: window.app object required.");
// console.log(window.app);

/**
 * Persist all UTM parameters from the current page inside the browser session
 * so they can be reused later in the application flow.
 *
 * @returns {void}
 */
function persistCampaignParamsInSession() {
  if (!window.sessionStorage || !window.location.search) {
    return;
  }

  const allowedCampaignParams = [
    "utm_medium",
    "utm_source",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "campaign_code",
    "ccode",
    "campaign_channel",
    "cchannel",
    "campaign_user",
    "cuser",
  ];
  const campaignParams = {};
  const queryParams = window.location.search.substring(1).split("&");

  const decodeQueryValue = (value) => {
    try {
      return decodeURIComponent((value || "").replace(/\+/g, " "));
    } catch (e) {
      return value || "";
    }
  };

  for (let i = 0; i < queryParams.length; i++) {
    const queryParam = queryParams[i];

    if (!queryParam) {
      continue;
    }

    const splitIndex = queryParam.indexOf("=");
    const rawName =
      splitIndex > -1 ? queryParam.substring(0, splitIndex) : queryParam;
    const rawValue = splitIndex > -1 ? queryParam.substring(splitIndex + 1) : "";
    const paramName = decodeQueryValue(rawName).toLowerCase();

    if (allowedCampaignParams.indexOf(paramName) === -1) {
      continue;
    }

    if (!/^[a-z0-9_]+$/.test(paramName)) {
      continue;
    }

    campaignParams[paramName] = decodeQueryValue(rawValue);
  }

  if (!Object.keys(campaignParams).length) {
    return;
  }

  try {
    window.sessionStorage.setItem(
      "bobCampaignParams",
      JSON.stringify(campaignParams),
    );
  } catch (e) {
    //
  }
}

// DOMContentLoaded -> page fully parsed without stylesheets
documentReady(() => {
  persistCampaignParamsInSession();

  // Initialize cookieHint
  // no longer needed -> cookiebot.js in index Layout
  //new CookieHint();

  // Initialize module
  new Module();

  // Initialize calculator
  new Calculator();

  // Forward campaign params on long-copy CTA clicks
  new LongCopy();

  // JavaScript hyphenation polyfill (https://github.com/ytiurin/hyphen)
  // @see ./app/web/js-hyphen
  // Bug: https://caniuse.com/#feat=css-hyphens
  try {
    const hyphenationMinWordLength = 10;
    const lang = document.documentElement.lang || "de";
    let hyphenationPattern;

    // Get current document language
    switch (lang) {
      case "en":
      case "en-gb":
      case "en-us":
        hyphenationPattern = hyphenationPatternsEnUs;
        break;
      case "fr":
        hyphenationPattern = hyphenationPatternsFr;
        break;
      case "it":
        hyphenationPattern = hyphenationPatternsIt;
        break;
      case "de-ch":
        hyphenationPattern = hyphenationPatternsDeCh;
        break;
      default:
        hyphenationPattern = hyphenationPatternsDe;
    }

    const hyphenate = createHyphenator(hyphenationPattern, { hyphenChar: "" });

    // Iterate through .headline elements
    Array.prototype.slice
      .call(document.getElementsByClassName("headline"))
      .forEach((headline) => {
        const headlineContent = headline.innerText.split(" ");
        const wordsToHyphenate = headlineContent.filter((word) => {
          return word.length > hyphenationMinWordLength;
        });

        if (wordsToHyphenate.length) {
          Array.prototype.slice.call(wordsToHyphenate).forEach((word) => {
            headline.innerHTML = headline.innerHTML.replace(
              word,
              hyphenate(word),
            );
            // console.log('hyphenate', word);
          });
        }
      });
  } catch (err) {
    //
  }
});

//fully loaded event
window.onload = () => {
  // const urlParams = new URLSearchParams(window.location.search);
  //console.log(window.location.search);
  const addtraction = "/addtraction.php" + window.location.search;

  fetch(addtraction, {
    method: "get",
  }).then((response) => {
    //console.log(response);
  });

  const tokenUrl = "/actions/blitz/csrf/json";
  fetch(tokenUrl, {
    method: "get",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      const inputs = document.querySelectorAll(
        'input[name^="CRAFT_CSRF_TOKEN"]',
      );
      for (const item of inputs) {
        //console.log('load: item initial: ' + item.value);
        item.value = data.token;
        //console.log('load: item after: ' + item.value);
      }
    });

  handleImageSizes();

  // Initialize lazyloading, https://github.com/verlok/lazyload
  const lazyLoad = new LazyLoad({
    /* eslint-disable */
    elements_selector: "[data-srcset], [data-src]",
    threshold: 150,
    class_loaded: "loaded",
    data_srcset: "srcset",
    callback_enter: function (element) {
      // Handle background images with data-srcset manually
      if (
        element.classList.contains("background-image--js") &&
        element.hasAttribute("data-srcset")
      ) {
        // For background images, we just set the data-was-processed attribute
        // The BackgroundImage class will handle the actual loading
        element.setAttribute("data-was-processed", "true");
      }
    },
    callback_loaded: function (element) {
      // Set the data-was-processed attribute for regular images
      if (!element.classList.contains("background-image--js")) {
        element.setAttribute("data-was-processed", "true");
      }
    },
    /* eslint-enable no-alert */
  });

  // Initialize carousel (before lazyloading)
  new Carousel(lazyLoad);

  // Initialize header
  //new Header();

  new MainNav();

  // Initialize faqAccordionsFilter
  new FaqAccordionsFilter();

  // Initialize PartnerDownloadsFilter
  new PartnerDownloadsFilter();

  // Initialize tooltip
  new Tooltip();

  // Initialize Newsticker
  new Readmore();

  // Initialize skipNavigation
  new skipNavigation();

  // Initialize modal instances
  Modal.init();

  // Initialize accordion
  new Accordion();

  // Scroll to target
  let scrollThreshold = 300; // negative value
  let anchorLinks = document.querySelectorAll('a[href^="#"]') || null;

  function scrollToTargetWatcher(hashValue) {
    if (!hashValue) {
      hashValue = window.location.hash || false;
      if (!hashValue) {
        return;
      } else {
        hashValue = decodeURIComponent(hashValue);
      }
    }
    let target =
      (hashValue &&
        (document.querySelector(hashValue) ||
          document.querySelector(`a[name="${hashValue.substring(1)}"]`))) ||
      false;

    let scrollTop = window.scrollY || 0;

    if (target) {
      window.scrollTo({
        top: target.getBoundingClientRect().top + scrollTop - scrollThreshold,
        behavior: "smooth",
      });
      history.pushState(null, null, hashValue);
      event.preventDefault();
    }
  }

  if (anchorLinks) {
    for (let item of anchorLinks) {
      // Event
      item.addEventListener("click", (event) => {
        let hashValue = item.getAttribute("href");
        scrollToTargetWatcher(hashValue);
      });
    }
  }

  // Check for Accordion Links
  let accordions = document.getElementsByClassName("accordion--js");

  if (accordions) {
    let accordionLinks =
      document.querySelectorAll('a[href*="#accordion-"]') || null;

    if (accordionLinks) {
      for (let accordionLink of accordionLinks) {
        accordionLink.addEventListener("click", (event) => {
          let str = accordionLink.getAttribute("href");
          let accordionHash = str.substring(str.indexOf("#"));

          scrollToTargetWatcher(accordionHash);
          let accordionTarget = document.querySelector(
            ".accordion-item " + accordionHash,
          );

          if (accordionTarget) {
            accordionTarget.parentElement.click();
          }
        });
      }
    }
  }

  scrollToTargetWatcher();
};
